import React from "react";

function CopyLinkIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 48 48"
        >
            <circle cx="24" cy="24" r="24" fill="#351C4F"></circle>
            <path
                fill="#fff"
                d="M30.79 17.217A4.115 4.115 0 0027.853 16c-1.11 0-2.147.43-2.934 1.217l-1.915 1.897a.919.919 0 000 1.324.919.919 0 001.324 0l1.897-1.897c.859-.859 2.362-.859 3.203 0a2.279 2.279 0 010 3.203l-3.131 3.186c-.86.858-2.363.858-3.204 0a.919.919 0 00-1.324 0 .919.919 0 000 1.324 4.114 4.114 0 002.935 1.216c1.11 0 2.147-.429 2.935-1.216l3.167-3.168a4.115 4.115 0 001.217-2.934c0-1.11-.448-2.148-1.235-2.935z"
            ></path>
            <path
                fill="#fff"
                d="M22.663 28.544l-1.896 1.915a2.279 2.279 0 01-3.204 0 2.279 2.279 0 010-3.203l3.168-3.168a2.279 2.279 0 013.203 0 .919.919 0 001.324 0 .919.919 0 000-1.324c-1.628-1.628-4.259-1.628-5.87 0l-3.167 3.15c-1.628 1.628-1.628 4.259 0 5.87A4.163 4.163 0 0019.156 33c1.056 0 2.13-.411 2.935-1.217l1.897-1.897a.919.919 0 000-1.324.934.934 0 00-1.325-.018z"
            ></path>
        </svg>
    );
}

export default CopyLinkIcon;
